/** Build-time public configuration (`VITE_*`); empty strings count as unset. */
export interface SiteEnv {
  VITE_ENTRA_TENANT_ID?: string;
  VITE_ENTRA_CLIENT_ID?: string;
  /** `login.direwolfai.com` — the custom URL domain that serves the sign-in pages. */
  VITE_ENTRA_AUTHORITY_HOST?: string;
  /** `direwolfai` — `direwolfai.ciamlogin.com`. */
  VITE_ENTRA_TENANT_SUBDOMAIN?: string;
  /** `api://account.direwolfai.com/<apiAppId>/Account.Manage`. */
  VITE_ACCOUNT_API_SCOPE?: string;
  /** Comma-separated https origins of Direwolf AI apps allowed as `?return=`. */
  VITE_RETURN_ORIGINS?: string;
  /** `1` = in-browser mock API and mock sign-in (local development, tests, the CSP harness). */
  VITE_API_MOCK?: string;
}

const KEYS = [
  'VITE_ENTRA_TENANT_ID',
  'VITE_ENTRA_CLIENT_ID',
  'VITE_ENTRA_AUTHORITY_HOST',
  'VITE_ENTRA_TENANT_SUBDOMAIN',
  'VITE_ACCOUNT_API_SCOPE',
  'VITE_RETURN_ORIGINS',
  'VITE_API_MOCK',
] as const;

export function readEnv(raw: Record<string, unknown> = import.meta.env): SiteEnv {
  const env: SiteEnv = {};
  for (const key of KEYS) {
    const value = raw[key];
    if (typeof value === 'string' && value.trim() !== '') env[key] = value.trim();
  }
  return env;
}

export const env: SiteEnv = readEnv();
